module.exports = __webpack_public_path__ + "static/media/calendar_2.9ec856f5.svg";